"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookContractRequest = void 0;
var LookContractRequest = /** @class */ (function () {
    function LookContractRequest() {
    }
    return LookContractRequest;
}());
exports.LookContractRequest = LookContractRequest;
;
//# sourceMappingURL=lookContract.request.js.map